import type { EventEmitter } from "node:events"
import type { TrackedEvent } from "@src/services/eventBusContract"
import { logger } from "@src/utils/logger"

// internal reference; starts out undefined
let bus: EventEmitter

export const setEventEmitter = (emitter: EventEmitter) => {
  bus = emitter
}

export type FreshnessTelemetryPayload = {
  chain: string
  rail: string
  fresh: boolean
  overridden: boolean
}

export const emitEvent = (type: TrackedEvent, data: unknown) => {
  if (!bus) {
    logger.error("EventEmitter not set!")
    return
  }
  bus.emit(type, data)
}
